// Replace the inline data with these imports
import sampleData1 from '../data/sampleData1.json';
import sampleData2 from '../data/sampleData2.json';
import sampleData3 from '../data/sampleData3.json';

// Then use the imported data in your functions
export const getSampleDataSet = (dataNumber) => {
  switch (dataNumber) {
    case 1: return sampleData1;
    case 2: return sampleData2;
    case 3: return sampleData3;
    default: return null;
  }
};